<h2 class="first_title">Anteprima Documento</h2>
<div class="content-page-wrapper">
    <div class="standardpanel">
        <div class="pdf-viewer-controls">

            <div class="row">
                <div class="col-sm-4 col-xs-4 d-flex justify-content-center">
                    <!-- Scarica PDF -->
                    <button class="btn btn-primary" (click)="downloadPdf()" title="Scarica il PDF">
                        <span class="glyphicon glyphicon-save-file"></span> Scarica pdf
                    </button>

                    <!-- Stampa PDF -->
                    <button class="btn btn-outline-secondary" (click)="printPdf()" aria-label="Stampa PDF" title="Stampa PDF">
                        <span class="glyphicon glyphicon-print"></span> Stampa
                    </button>

                </div>
                <div class="col-sm-4 col-xs-4 d-flex justify-content-center">
                    <!-- Pagina precedente -->
                    <button class="btn btn-outline-primary" (click)="prevPage()" [disabled]="page <= 1"
                        aria-label="pagina precedente"
                        title="Pagina precedente">
                        <i class="fas fa-arrow-left"></i>
                    </button>

                    <!-- Indicatore pagina -->
                    <div class="row page-indicator">
                        <div class="col-sm-4">Pagina</div>
                        <div class="col-sm-4">
                            <input type="number" [attr.aria-label]="'pagina ' + page" class="form-control" [value]="page" (change)="goToPage($event)"
                                [min]="1" [max]="totalPages" style="width: 60px; text-align: center;" />
                        </div>
                        <div class="col-sm-4">di <strong>{{ totalPages }}</strong></div>
                    </div>

                    <!-- Pagina successiva -->
                    <button class="btn btn-outline-primary" (click)="nextPage()" [disabled]="page >= totalPages"
                        aria-label="pagina successiva"
                        title="Pagina successiva">
                        <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
                <div class="col-sm-4 col-xs-4 d-flex justify-content-center">
                    <!-- Zoom in -->
                    <button class="btn btn-outline-secondary" (click)="zoomIn()" aria-label="Ingrandisci" title="Ingrandisci">
                        <i class="fas fa-search-plus"></i>
                    </button>

                    <!-- Zoom out -->
                    <button class="btn btn-outline-secondary" (click)="zoomOut()" aria-label="Rimpicciolisci" title="Rimpicciolisci">
                        <i class="fas fa-search-minus"></i>
                    </button>
                </div>
            </div>
        </div>

        <pdf-viewer [src]="pdfSrc" [page]="page" [zoom]="zoom" [original-size]="false" [stick-to-page]="true"
            [show-all]="true" (pageChange)="onPageChange($event)" (after-load-complete)="afterLoadComplete($event)"
            style="height: 600px; width: 100%; display: block;">
        </pdf-viewer>

    </div>
</div>